import axios from "axios";
import { Global } from '../utils/general';
import headerRequest from "../utils/headers";

const API_URL = Global.url;

class ReportService {
  getReport(
  url,
  { empresa_id = -1, tipoEquipo = -1, categoria = -1, estadoEqp = -1 },
  { search = '', page = 1, pageSize = 20, pagination = '' }
) {
  const ruta = `${API_URL}/report/general-inventory?url=${url}&search=${search}&page=${page}&pageSize=${pageSize}&pagination=${pagination}&empresa_id=${empresa_id}&tipoEquipo=${tipoEquipo}&categoria=${categoria}&estadoEqp=${estadoEqp}`;
  
  return axios.post(ruta, {}, {
    headers: headerRequest(),
  }).catch((error) => {
    return error;
  });
}

}

export default new ReportService();
